import { z } from 'zod';

import { ReschedulePolicySchema } from './endpoints';

export enum ReschedulePolicyCutoffUnit {
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
}

export enum ReschedulePolicyField {
  NOTES = 'notes',
}

export type ReschedulePolicy = z.infer<typeof ReschedulePolicySchema>;
